import { GET_USER_MENU_FAIL, GET_USER_MENU_SUCCESS } from "./actionTypes"

const initialState = {
  userMenu: [],
  error: {},
}

const userMenu = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_MENU_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USER_MENU_SUCCESS:
      return {
        ...state,
        userMenu: action.payload,
      }

    default:
      state = { ...state }
      break
  }
  return state
}

export default userMenu
